import Image from "next/image";
import style from "./FakeResult.module.scss";

function FakeResult({ openAuthHandler, isVisible }) {
	return (
		<div className={`${style.wrapper} ${isVisible ? style.visible : ""}`}>
			<Image onClick={openAuthHandler} src={"/remove_back/magic_bg/blur_result.jpg"} width={600} height={600} className={style.image} alt="Blurred result" />
		</div>
	);
}

export default FakeResult;
